<template>
	<div>
		<label :for="question.Key">
			{{ question.Value.Description }}
			<i v-if="question.Value.Required">*</i>

			<info-text :info-text="question.Value.ToolTipText"></info-text>
			<div class="layout layout--middle">
				<div class="layout__item u-4/5">
					<datepicker
						:initialView="question.Key.toLowerCase().indexOf('birth') > -1 ? 'year' : 'day'"
						:open-date="
							question.Key.toLowerCase().indexOf('birth') > -1 ? new Date(1983, 0, 1) : defaultStartDate
						"
						:language="language"
						v-model="datePickerDate"
						@change="emitChange"
						:name="question.Key"
						ref="picker"
						v-on:input="selectedDate"
						v-on:closed="selectedDate"
						:format="'dd-MM-yyyy'"
						:monday-first="true"
						:disabled-dates="disabledDates"
					></datepicker>
				</div>
				<div class="layout__item u-1/5">
					<svg class="icon icon-calendar" @click="$refs.picker.showCalendar()">
						<use xlink:href="#icon-calendar"></use>
					</svg>
				</div>
			</div>
		</label>
		<symbol id="icon-calendar" viewBox="0 0 32 32">
			<path
				d="M10 12h4v4h-4zM16 12h4v4h-4zM22 12h4v4h-4zM4 24h4v4h-4zM10 24h4v4h-4zM16 24h4v4h-4zM10 18h4v4h-4zM16 18h4v4h-4zM22 18h4v4h-4zM4 18h4v4h-4zM26 0v2h-4v-2h-14v2h-4v-2h-4v32h30v-32h-4zM28 30h-26v-22h26v22z"
			></path>
		</symbol>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { nl } from 'vuejs-datepicker/src/locale';
import { mask } from 'vue-the-mask';
import InfoText from '@/partials/InfoText';

export default {
	directives: { mask },
	props: ['question'],
	components: {
		Datepicker,
		InfoText,
	},
	data() {
		return {
			format: 'dd-MM-yyyy',
			language: nl,
			datePickerDate: '',
			defaultBirthDay: new Date(1975, 6, 1),
		};
	},
	created() {
		if (this.question.Value.UserValue) {
			this.datePickerDate = this.stringToDate(this.question.Value.UserValue);
		} else {
			this.datePickerDate = '';
		}
	},

	computed: {
		disabledDates: function () {
			let disabledDates = {
				from: null,
				to: null,
			};
			let dateRange = this.question.Value.DateRange;
			if (dateRange) {
				let minDate = dateRange.MinDate.split('-').reverse();
				minDate[2] = parseInt(minDate[2]);
				disabledDates.to = new Date(...minDate);

				let maxDate = dateRange.MaxDate.split('-').reverse();
				maxDate[2] = parseInt(maxDate[2]) + 1;

				disabledDates.from = new Date(...maxDate);
			}
			return disabledDates;
		},
		defaultStartDate: function () {
			return new Date();
		},
	},

	methods: {
		stringToDate: function (dateString) {
			let dateParts = dateString.split('-').reverse();
			dateParts[1] = parseInt(dateParts[1]) - 1;
			return new Date(...dateParts);
		},
		selectedDate: function (e) {
			if (e) {
				this.datePickerDate = e;
				setTimeout(() => {
					var formattedDate = this.getFormattedDate(e);

					this.question.Value.UserValue = formattedDate;
					this.emitChange();
				}, 100);
			}
		},
		hasFullDate() {
			return (
				this.question &&
				this.question.Value &&
				this.question.Value.UserValue &&
				this.question.Value.UserValue.length === 10
			);
		},
		getFormattedDate: function (date) {
			if (!date) {
				return;
			}
			let days = date.getDate();
			let month = date.getMonth() + 1;
			if (days < 10) {
				days = '0' + days;
			}
			if (month < 10) {
				month = '0' + month;
			}
			return `${days}-${month}-${date.getFullYear()}`;
		},
		emitChange: function () {
			this.$emit('updatedvalue', {
				update: this.question.Value.RequiresRefresh,
				question: this.question,
			});
		},
	},
};
</script>

<style>
.icon {
	display: inline-block;
	width: 1.5em;
	height: 1.5em;
	stroke-width: 0;
	stroke: currentColor;
	fill: currentColor;
}

.rtl {
	direction: rtl;
}

.vdp-datepicker {
	position: relative;
	text-align: left;
}

.vdp-datepicker * {
	box-sizing: border-box;
}

.vdp-datepicker__calendar {
	position: absolute;
	z-index: 100;
	background: #fff;
	width: 300px;
	border: 1px solid #ccc;
}

.vdp-datepicker__calendar header {
	display: block;
	line-height: 40px;
}

.vdp-datepicker__calendar header span {
	display: inline-block;
	text-align: center;
	width: 71.42857142857143%;
	float: left;
}

.vdp-datepicker__calendar header .prev,
.vdp-datepicker__calendar header .next {
	width: 14.285714285714286%;
	float: left;
	text-indent: -10000px;
	position: relative;
}

.vdp-datepicker__calendar header .prev:after,
.vdp-datepicker__calendar header .next:after {
	content: '';
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
	border: 6px solid transparent;
}

.vdp-datepicker__calendar header .prev:after {
	border-right: 10px solid #000;
	margin-left: -5px;
}

.vdp-datepicker__calendar header .prev.disabled:after {
	border-right: 10px solid #ddd;
}

.vdp-datepicker__calendar header .next:after {
	border-left: 10px solid #000;
	margin-left: 5px;
}

.vdp-datepicker__calendar header .next.disabled:after {
	border-left: 10px solid #ddd;
}

.vdp-datepicker__calendar header .prev:not(.disabled),
.vdp-datepicker__calendar header .next:not(.disabled),
.vdp-datepicker__calendar header .up:not(.disabled) {
	cursor: pointer;
}

.vdp-datepicker__calendar header .prev:not(.disabled):hover,
.vdp-datepicker__calendar header .next:not(.disabled):hover,
.vdp-datepicker__calendar header .up:not(.disabled):hover {
	background: #eee;
}

.vdp-datepicker__calendar .disabled {
	color: #ddd;
	cursor: default;
}

.vdp-datepicker__calendar .flex-rtl {
	display: flex;
	width: inherit;
	flex-wrap: wrap;
}

.vdp-datepicker__calendar .cell {
	display: inline-block;
	padding: 0 5px;
	width: 14.285714285714286%;
	height: 40px;
	line-height: 40px;
	text-align: center;
	vertical-align: middle;
	border: 1px solid transparent;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
	cursor: pointer;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
	border: 1px solid #4bd;
}

.vdp-datepicker__calendar .cell.selected {
	background: #4bd;
}

.vdp-datepicker__calendar .cell.selected:hover {
	background: #4bd;
}

.vdp-datepicker__calendar .cell.selected.highlighted {
	background: #4bd;
}

.vdp-datepicker__calendar .cell.highlighted {
	background: #cae5ed;
}

.vdp-datepicker__calendar .cell.highlighted.disabled {
	color: #a3a3a3;
}

.vdp-datepicker__calendar .cell.grey {
	color: #888;
}

.vdp-datepicker__calendar .cell.grey:hover {
	background: inherit;
}

.vdp-datepicker__calendar .cell.day-header {
	font-size: 75%;
	white-space: nowrap;
	cursor: inherit;
}

.vdp-datepicker__calendar .cell.day-header:hover {
	background: inherit;
}

.vdp-datepicker__calendar .month,
.vdp-datepicker__calendar .year {
	width: 33.333%;
}

.vdp-datepicker__clear-button,
.vdp-datepicker__calendar-button {
	cursor: pointer;
	font-style: normal;
}

.vdp-datepicker__clear-button.disabled,
.vdp-datepicker__calendar-button.disabled {
	color: #999;
	cursor: default;
}
</style>
